export default __webpack_public_path__ + "static/media/sms-alert-5-daniel_simon.6307c307.wav";